import React, { Component } from "react";
import { Dialog } from "@material-ui/core";
import { DialogH1, Dialogp, DesignedButtonD } from "@/Common/UploadCompleted/UploadCompleteStyle";
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import i18n from "../../i18n";
const styles = {
  maxWidthXs : {
    maxWidth : "520px"
  }
};
class OneBtnDialog extends Component {
  render() {
  
    
    const content = {
        //my video page dialog
      'removeTemplate': {
        type: 'removeTemplate',
        dialogBodyText1:i18n.t("onebtndialog.removeTemplate.dialogBodyText1"),
        dialogHeadText : i18n.t("global.success"),
      },
      'failremoveTemplate': {
        type: 'failremoveTemplate',
        dialogBodyText1:i18n.t("onebtndialog.failremoveTemplate.dialogBodyText1"),
        dialogHeadText : i18n.t("global.fail"),
      },
      'overtime': {
        type: 'overtime',
        dialogBodyText1:i18n.t("onebtndialog.overtime.dialogBodyText1"),
        dialogHeadText : i18n.t("global.alert"),
      },
      'noteditable': {
        type: 'noteditable',
        dialogBodyText1:i18n.t("onebtndialog.renderVideo.isEditable"),
        dialogHeadText : i18n.t("global.alert"),
      },
      'copyVideo': {
        type: 'copyVideo',
        dialogBodyText1:i18n.t("onebtndialog.copyVideo.dialogBodyText1"),
        dialogHeadText : i18n.t("global.alert"),
      },
      'failCopyVideo' : {
        type: 'failCopyVideo',
        dialogBodyText1:i18n.t("onebtndialog.failCopyVideo.dialogBodyText1"),
        dialogBodyText2:"",
        dialogHeadText :i18n.t("global.fail"),
      },
      'failMoveEditVideoPage': {
        type: 'failMoveEditVideoPage',
        dialogBodyText1:i18n.t("onebtndialog.failMoveEditVideoPage.dialogBodyText1"),
        dialogBodyText2:i18n.t("onebtndialog.failMoveEditVideoPage.dialogBodyText2"),
        dialogHeadText : i18n.t("global.fail"),
      },
      'failEditVideo' : {
        type: 'failEditVideo',
        dialogBodyText1:i18n.t("onebtndialog.failEditVideo.dialogBodyText1"),
        dialogBodyText2:i18n.t("onebtndialog.failEditVideo.dialogBodyText2"),
        dialogHeadText :i18n.t("global.fail"),
      },
      'renderingGif': {
        type: 'renderingGif',
        dialogBodyText1: i18n.t("onebtndialog.renderingAler.dialogBodtText1"),
        dialogHeadText: i18n.t("global.alert"),
      },
    
    
    
      // completed payment dialog
      'SuccessSubscriptionPayment' : {
        type: 'SuccessSubscriptionPayment',
        dialogBodyText1:i18n.t("onebtndialog.SuccessSubscriptionPayment.dialogBodyText1"),
        dialogBodyText2:i18n.t("onebtndialog.SuccessSubscriptionPayment.dialogBodyText2"),
        dialogHeadText :i18n.t("select.design"),
      },
      'SuccessperPayment' : {
        type: 'SuccessperPayment',
        dialogBodyText1:i18n.t("onebtndialog.SuccessperPayment.dialogBodyText1"),
        dialogBodyText2:i18n.t("onebtndialog.SuccessperPayment.dialogBodyText2"),
        dialogHeadText :i18n.t("global.alert"),
      },
    
    
      // signup page dialog
      'tosAgree' : {
        type: 'tosAgree',
        dialogBodyText1:i18n.t("onebtndialog.tosAgree.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'requestEmail' : {
        type: 'requestEmail',
        dialogBodyText1:i18n.t("onebtndialog.requestEmail.dialogBodyText1"),
        dialogBodyText2:i18n.t("onebtndialog.requestEmail.dialogBodyText2"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'UsedEmail' : {
        type: 'UsedEmail',
        dialogBodyText1:i18n.t("onebtndialog.UsedEmail.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'signupError' : {
        type: 'signupError',
        dialogBodyText1:i18n.t("onebtndialog.signupError.dialogBodyText1"),
        dialogBodyText2:i18n.t("onebtndialog.signupError.dialogBodyText2"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'sendEmail' : {
        type: 'sendEmail',
        dialogBodyText1:i18n.t("onebtndialog.sendEmail.dialogBodyText1"),
        dialogBodyText2:i18n.t("onebtndialog.sendEmail.dialogBodyText2"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'checkEmail' : {
        type: 'checkEmail',
        dialogBodyText1:i18n.t("onebtndialog.checkEmail.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'verifyNumber' : {
        type: 'verifyNumber',
        dialogBodyText1:i18n.t("onebtndialog.verifyNumber.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
    
      //payment page dialog 
      'errorPerPayment' : {
        type: 'errorPerPayment',
        dialogBodyText1:i18n.t("onebtndialog.errorPerPayment.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'errorTermPayment': {
        type: 'errorTermPayment',
        dialogBodyText1:i18n.t("onebtndialog.errorTermPayment.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'errorSubscriptionPayment' : {
        type: 'errorSubscriptionPayment',
        dialogBodyText1:i18n.t("onebtndialog.errorSubscriptionPayment.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'errorClientPayment' : {
        type: 'errorClientPayment',
        dialogBodyText1:i18n.t("onebtndialog.errorClientPayment.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
    
      //NotConfirmedTemplates page dialog
      'agreeTemplate' : {
        type: 'agreeTemplate',
        dialogBodyText1:i18n.t("onebtndialog.agreeTemplate.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'failAgreeTemplate' : {
        type: 'failAgreeTemplate',
        dialogBodyText1:i18n.t("onebtndialog.failAgreeTemplate.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      
      // login page dialog
      'checkInfo' : {
        type: 'checkInfo',
        dialogBodyText1:i18n.t("onebtndialog.checkInfo.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'failLogin' : {
        type: 'failLogin',
        dialogBodyText1:i18n.t("onebtndialog.failLogin.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
    
      'sendPassword' : {
        type: 'sendPassword',
        dialogBodyText1:i18n.t("onebtndialog.sendPassword.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'notRegisteredEmail' : {
        type: 'notRegisteredEmail',
        dialogBodyText1:i18n.t("onebtndialog.notRegisteredEmail.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'severError' : {
        type: 'severError',
        dialogBodyText1:i18n.t("onebtndialog.severError.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      //idsetting page dialog 
      'reWritePassword' : {
        type: 'reWritePassword',
        dialogBodyText1:i18n.t("onebtndialog.reWritePassword.dialogBodyText1"),
        dialogBodyText2:i18n.t("onebtndialog.reWritePassword.dialogBodyText2"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'failPassword' : {
        type: 'failPassword',
        dialogBodyText1 :i18n.t("onebtndialog.failPassword.dialogBodyText1"),
        dialogBodyText2:i18n.t("onebtndialog.failPassword.dialogBodyText2"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'successPassword' : {
        type: 'successPassword',
        dialogBodyText1:i18n.t("onebtndialog.successPassword.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'successName' : {
        type: 'successName',
        dialogBodyText1:i18n.t("onebtndialog.successName.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'denyEmail' : {
        type: 'denyEmail',
        dialogBodyText1:i18n.t("onebtndialog.denyEmail.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'refund' : {
        type: 'refund',
        dialogBodyText1:i18n.t("onebtndialog.refund.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'failRefund' : {
        type: 'failRefund',
        dialogBodyText1:i18n.t("onebtndialog.failRefund.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'failUnschedule' : {
        type: 'failUnschedule',
        dialogBodyText1:i18n.t("onebtndialog.failUnschedule.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'refuseCouponRefund' : {
        type: 'refuseCouponRefund',
        dialogBodyText1:i18n.t("onebtndialog.refuseCouponRefund.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'errorRefund' : {
        type: 'errorRefund',
        dialogBodyText1:i18n.t("onebtndialog.errorRefund.dialogBodyText1"),
        dialogBodyText2:i18n.t("onebtndialog.errorRefund.dialogBodyText2"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'requestAdminLogin' : {
        type: 'requestAdminLogin',
        dialogBodyText1:i18n.t("onebtndialog.requestAdminLogin.dialogBodyText1"),
        dialogHeadText :"경고",
      },
      'changeDesingerNickName' : {
        type: 'changeDesingerNickName',
        dialogBodyText1:i18n.t("onebtndialog.changeDesingerNickName.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'changeDesingerDescription' : {
        type: 'changeDesingerDescription',
        dialogBodyText1:i18n.t("onebtndialog.changeDesingerDescription.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'requestDesignerLogin' : {
        type: 'requestDesignerLogin',
        dialogBodyText1:i18n.t("onebtndialog.requestDesignerLogin.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'requestMinText' : {
        type: 'requestMinText',
        dialogBodyText1: i18n.t("onebtndialog.requestMinText.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'freevideoalert' : {
        type: 'freevideoalert',
        dialogBodyText1: i18n.t("designselectpopup.confirmationdialog.makefreetext"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'requiredNickName' : {
        type: 'requiredNickName',
        dialogBodyText1: i18n.t("web.signup.wrong.nickname"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'requiredPassword' : {
        type: 'requiredPassword',
        dialogBodyText1: i18n.t("web.signup.password.wrong.text"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'shareLinkBlock' : {
        type: 'shareLinkBlock',
        dialogBodyText1: i18n.t("web.myvideo.alert.sharelink.popup.block"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'shareSuccess' : {
        type: 'shareSuccess',
        dialogBodyText1: i18n.t("web.myvideo.alert.sharelink.clipboard.success"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'shareFail' : {
        type: 'shareFail',
        dialogBodyText1: i18n.t("web.myvideo.alert.sharelink.failed"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'removeWaterMark' : {
        type: 'removeWaterMark',
        dialogBodyText1: i18n.t("onebtndialog.remove.watermark.alert"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'reportSucces' : {
        type: 'reportSucces',
        dialogBodyText1: i18n.t("onebtndialog.report.success"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'commentRemove' : {
        type: 'commentRemove',
        dialogBodyText1: i18n.t("onebtndialog.commentRemove.success"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'reportAlready' : {
        type: 'reportAlready',
        dialogBodyText1: i18n.t("onebtndialog.reportAlready"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'galleryUploadSuccess' : {
        type: 'galleryUploadSuccess',
        dialogBodyText1: i18n.t("web.gallery.upload.success"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'galleryDelete' : {
        type: 'galleryDelete',
        dialogBodyText1: i18n.t("web.gallery.delete.success"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'templateNotFount' : {
        type: 'templateNotFount',
        dialogBodyText1: i18n.t("onebtndialog.templateNotFound.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'removeAccount' : {
        type: 'removeAccount',
        dialogBodyText1: i18n.t("onebtndialog.removeAccount.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'createAccount' : {
        type: 'createAccount',
        dialogBodyText1: i18n.t("onebtndialog.createAccount.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'userBlockAlert': {
        type: 'userBlockAlert',
        dialogBodyText1: i18n.t("onebtndialog.userBlockAlert.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'businessMaxiumAccountAlert': {
        type: 'businessMaxiumAccountAlert',
        dialogBodyText1: i18n.t("onebtndialog.businessMaxiumAccountAlert.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      },
      'waitForSownloadShortsVideo': {
        type: 'waitForSownloadShortsVideo',
        dialogBodyText1: i18n.t("onebtndialog.waitForSownloadShortsVideo.dialogBodyText1"),
        dialogHeadText :i18n.t("global.alert"),
      }
    }
    const { 
      closeBtn,
      open,
       DesignedButtonText ,
       noButton,
       left,
       dialogType,
       subBodyText,
       onButtonClick
      } = this.props;
    const what = content[dialogType]
    const check = what.type === this.props.dialogType
    
    return (
      <>
        <Dialog fullWidth = {this.props.fullWidth} className={classNames(this.props.classes.paperWidthXs)} maxWidth ={"sm"} open={open} onClose={closeBtn}>
          <div className="closeBtn" onClick={closeBtn}>
            <div className="closeBar1" />
            <div className="closeBar2" />
          </div>
          <DialogH1>{check ? what.dialogHeadText : i18n.t("global.alert")}</DialogH1>
          <Dialogp>
            <div>{check ? what.dialogBodyText1 : null}</div>
            <div>{check ? what.dialogBodyText2 : null}</div>
            <div>{subBodyText ? subBodyText : null}</div>
          </Dialogp>
          <div style={{ padding: "1.5rem 0" }}>
            {noButton 
              ? null 
              : <DesignedButtonD
                  color={"darkGray"}
                  text={DesignedButtonText || i18n.t("global.confirm")}
                  onClick={onButtonClick}
                  left={left}
                />
            }
          </div>
        </Dialog>
      </>
    );
  }
}

export default withStyles(styles)(OneBtnDialog);
